// extracted by mini-css-extract-plugin
export default {"root":"PauseDurationFilter_root__Utkza"};